import React, { FC } from "react";
import { Text } from "@primer/react";

export interface TotalPrintedPrimerProps {
  totalPrinted: number;
  totalItems: number;
  totalPrints?: number;
  totalReprints?: number;
}

export const TotalPrintedPrimer: FC<TotalPrintedPrimerProps> = ({
  totalPrinted,
  totalItems,
  totalPrints,
  totalReprints,
}) => (
  <Text fontSize={0} className="total-printed-container">
    Printed <Text as="span" className="total-printed-bold">{totalPrinted}</Text>
    {" / "}
    <Text as="span" className="total-printed-bold">{totalItems}</Text> Badges
    {totalPrints !== undefined && (
      <>
        {" — "}
        <Text as="span" className="total-printed-bold">{totalPrints}</Text>
        {" total prints"}
        {totalReprints !== undefined && (
          <>
            {" ("}
            <Text as="span" className="total-printed-bold">{totalReprints}</Text>
            {" reprints)"}
          </>
        )}
      </>
    )}
  </Text>
);
